import { render, staticRenderFns } from "./TagsBar.vue?vue&type=template&id=48dadd7f"
import script from "./TagsBar.vue?vue&type=script&lang=js"
export * from "./TagsBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports